import { gql } from '@apollo/client'

export const Query = gql`
  query EditAsset($companyId: ID!, $filters: AssetFilters) {
    assets(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        name
        barcode {
          id
          barcode
        }
        serialNumber
        warehouse {
          id
          name
        }
        assetCase {
          id
        }
        assetType {
          id
        }
        warehouseLocation
        notes
        mystroTestId
      }
    }
  }
`
